import React from 'react';
import { Box } from '@styleseat/ui';
import { PortalOverlay } from '../../../../ui';
import Modal from '../../../../Modal';
import MultiFactorAuthForm from '../../../../shared/login/MultiFactorAuthForm';
import { MultiFactorAuthChoiceType, MultiFactorAuthMethod } from '../../../../shared/login/MultiFactorAuthForm/types';

export type MultiFactorAuthFormOverlayProps = {
  mfaChoices: MultiFactorAuthChoiceType[] | null;
  mfaMethod: MultiFactorAuthMethod | null;
  isLoading: boolean;
  userStateErrors: any;
  handleSignInUser: (mfaCode: string, currentMfaMethod?: MultiFactorAuthMethod) => Promise<void>;
  onClose: () => void;
};

const MultiFactorAuthFormOverlay: React.FCWithChildren<MultiFactorAuthFormOverlayProps> = ({
  mfaChoices,
  mfaMethod,
  isLoading,
  userStateErrors,
  handleSignInUser,
  onClose,
}) => {
  const handleOnRequestCode = mfaMethodValue => handleSignInUser(undefined, mfaMethodValue);
  return (
    <PortalOverlay name="inline-login-mfa">
      <Modal
        initialOpen
        onClose={onClose}
        zIndex={9999}
        testID="signInAndSignUp__multiFactorAuthForm"
      >
        <Box paddingTop={24}>
          <MultiFactorAuthForm
            mfaChoices={mfaChoices}
            mfaMethod={mfaMethod}
            isSubmitting={isLoading}
            errors={userStateErrors}
            onRequestCode={handleOnRequestCode}
            onVerify={handleSignInUser}
          />
        </Box>
      </Modal>
    </PortalOverlay>
  );
};

export default MultiFactorAuthFormOverlay;
